module.exports = __webpack_public_path__ + "img/2.2e2f8f60.svg";